import { render, staticRenderFns } from "./isoManagement.vue?vue&type=template&id=37498108&scoped=true"
import script from "./isoManagement.vue?vue&type=script&lang=js"
export * from "./isoManagement.vue?vue&type=script&lang=js"
import style0 from "./isoManagement.vue?vue&type=style&index=0&id=37498108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37498108",
  null
  
)

export default component.exports